import { getFeature } from 'Cloud/Application/FeaturesEs6';

const overquota256TariffTrialId = getFeature('overquota-ab-tariff-trial-id') || 'W256GB_1m_overquater_clamp_force_trial';
const overquota256TariffDiscountId = getFeature('overquota-ab-tariff-discount-id') || 'W256GB_1y_overquater_clamp';
const overquota256TariffVariantDId = getFeature('overquota-ab-tariff-vard-id') || 'W256G1m_single_quota_2022_cloud';

// CLOUDWEB-19017
// Показ скидки/триала в растяжках/модалках (Облако)
const overquotaAbTariff: 'a' | 'b' | 'c' | 'd' | undefined = getFeature('overquota-ab-tariff');

export const overquotaAbTariffB = overquotaAbTariff === 'b';
export const overquotaAbTariffC = overquotaAbTariff === 'c';
export const overquotaAbTariffD = overquotaAbTariff === 'd';

export const overquotaAbTariffBC = overquotaAbTariffB || overquotaAbTariffC;

export const overquotaAbVariantTariffId = overquotaAbTariffB
    ? overquota256TariffTrialId
    : overquotaAbTariffC
    ? overquota256TariffDiscountId
    : overquotaAbTariffD
    ? overquota256TariffVariantDId
    : '';

export const overquotaAbTariffName = overquotaAbTariffB ? 'trial' : overquotaAbTariffC ? 'discount' : overquotaAbTariffD ? 'vard' : '';
